<template>
    <div class="number">
        <div class="display-direction">
            <font-awesome-icon icon="fa-solid fa-angle-up" class="color-transparent" v-if="direction===null"/>
            <font-awesome-icon icon="fa-solid fa-angle-up" class="odd-direction-up animate-flicker" v-if="direction==='up'"/>
            <font-awesome-icon icon="fa-solid fa-angle-down" class="odd-direction-down animate-flicker" v-if="direction==='down'"/>
            <font-awesome-icon icon="fa-solid fa-circle-pause" class="odd-direction-pause" v-if="direction==='pause'"/>
        </div>
        <div class="display-odd" :class="(parseFloat(newOdd) < 0)? 'display-odd-negative' : ''">
            {{ (newOdd !== 'NaN' && newOdd !== null)? newOdd : ''}}
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DisplayUpdatedValue',
        props: {
            newOdd : String,
            oldOdd : String,
            batch : Number
        },
        watch: {
            'batch': function() {
                this.setDirection()
            },
        },
        methods: {
            setDirection() {
                if(this.newOdd === null || this.newOdd === "NaN") {
                    this.direction = "pause"
                }
                else if(parseFloat(this.newOdd) === parseFloat(this.oldOdd)) {
                    this.direction = null
                }
                else if(parseFloat(this.newOdd) < parseFloat(this.oldOdd)) {
                    this.direction = 'down'
                }
                else{
                    this.direction = 'up'
                }
            }
        },
        data() {
          return {
              direction:null,
          }
        },
        mounted() {
            this.setDirection()
        }
    }
</script>